import { PublicKey } from "@solana/web3.js";

export const connectionsOptions = {
    preflightCommitment: 'processed',
};

export const programAddress = new PublicKey(
    'HZy4kyk53Zsrzgv84fuRmuXFNar9VAyJmqwVZtK1iEVy'
);
